<template>
  <div class="VueCarousel-slide">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Slide",
  data() {
    return {
      width: null,
    }
  },
  props: {
    pagin: {
      type: String,
      default: '<div></div>'
    }
  }
}
</script>

<style>
  .VueCarousel-slide {
    flex-basis: inherit;
    flex-grow: 0;
    flex-shrink: 0;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Slide.vue